<template>

  <v-autocomplete
      outlined
      chips
      small-chips
      deletable-chips
      clearable
      hide-details
      :label="selectorLabel"
      :disabled="disabled"
      :multiple="multiple"
      item-text="label"
      item-value="code"
      :items="statuses"
      v-model="activeSelection"
      @change="emitChange" />

</template>

<script>
export default {
  name: 'OrderStatusSelector',

  props: {
    statuses: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: true
    },
    selectorLabel: {
      type: String,
      default: 'Order status'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      activeSelection: null
    }
  },

  methods: {
    emitChange () {
      this.$emit('changed', this.activeSelection)
    }
  }
}
</script>

<style>
</style>
